module.exports = __webpack_public_path__ + "static/media/mongo.b3992731.gif";